import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { showMobile } from "./helpers/utils";
import { useSelector } from "react-redux";
import { Toast } from "primereact/toast";

import Header from "../../_shared/Header/Header";
import LayoutWrapper from "./motorWrapper.style";

import logo from "../../assets/images/logos/Tawuniya-Logo_blue.svg";


const Sidebar = React.lazy(() => import("../../_shared/SideBar/Sidebar"));

const MotorWrapper = (props) => {

  const toast = useRef(null);
  const { i18n, t } = useTranslation();
  const showRTL = i18n.dir() === 'rtl';
  const loading = useSelector((state) => state.common.isLoading);
  const errorMessage = useSelector((state) => state.common.errorMessage);

  useEffect(() => {
    if (errorMessage) {
      toast.current.show({
        severity: "error",
        summary: "Error Message",
        detail: errorMessage,
        life: 7000,
      });
    }
  }, [errorMessage]);


  const config = {
    steps: [
      {
        label: t("PERSONAL_DETAIL.HEADING"),
      },
      {
        label: t("STEPPER.VEHICLEDETAILS"),
      },
      {
        label: t("STEPPER.POLICYCOVERAGE"),
      },
      {
        label: t("STEPPER.PAYMENT"),
      },
      {
        label: t("STEPPER.CONFIRMATION"),
      },
    ],
  };

  return (
    <LayoutWrapper>
      <Toast ref={toast} />
      {loading && (
        <>
          <div className="loader-overlay">
            <img src={logo} alt="" />
          </div>
        </>
      )}
      <div
        className={
          `container ${showMobile() ? "full-width-div" : "full-width-div-mob"}` +
          (showRTL ? " ar" : "")
        }
      >
        <div className="row">
          <div
            className={`col-sm-12 col-md-12 col-lg-12 col-xl-3  ${
              showMobile() ? "left-sec" : "left-sec-mob"
            }`}
          >
            <Sidebar
              applicationName={t("LEFTFOOTER.HEADING.MOTOR")}
              showCarousel={false}
              showSteps={true}
              config={config}
              hideAvatar={true}
              showMobile={!showMobile()}
            />
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-9 right-nav">
            <div className={`${showMobile() ? "header" : "header-mob"}`}>
              <Header
                hideContent={showMobile() ? false : true}
                applicationName={t("LEFTFOOTER.HEADING.MOTOR")}
              />
            </div>
            <div className={`${showMobile() ? "component" : "component-mob"}`}>
              <div
                className={`${
                  showMobile()
                    ? "container-fluid container-fluid px-0 p-md-2 p-lg-5"
                    : "container-wrapper-mob mb-0 mx-auto"
                }`}
              >
                <div className="d-flex w-100 justify-content-center align-items-center my-3 mx-auto">
                </div>
                <props.component {...props} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutWrapper>
  );
};

MotorWrapper.propTypes = {
  component: PropTypes.any,
};

export default MotorWrapper;
